import actions from './actions';

const {
  ADD_TECHNICAL_DOCS_BEGIN,
  ADD_TECHNICAL_DOCS_FAILED,
  ADD_TECHNICAL_DOCS_SUCCESS,
  DELETE_TECHNICAL_DOCS_BEGIN,
  DELETE_TECHNICAL_DOCS_FAILED,
  DELETE_TECHNICAL_DOCS_SUCCESS,
  GET_TECHNICAL_DOCS_BEGIN,
  GET_TECHNICAL_DOCS_FAILED,
  GET_TECHNICAL_DOCS_SUCCESS,
  UPDATE_TECHNICAL_DOCS_BEGIN,
  UPDATE_TECHNICAL_DOCS_FAILED,
  UPDATE_TECHNICAL_DOCS_SUCCESS,
} = actions;

const initState = {
  total: 0,
  technicalDocs: [],
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};

const TechnicalDocsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_TECHNICAL_DOCS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_TECHNICAL_DOCS_SUCCESS:
      return {
        ...state,
        technicalDocs: data.technicalDocs,
        total: data.total,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_TECHNICAL_DOCS_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_TECHNICAL_DOCS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_TECHNICAL_DOCS_SUCCESS:
      return {
        ...state,
        technicalDocs: data,
        loading: false,
      };
    case ADD_TECHNICAL_DOCS_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_TECHNICAL_DOCS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_TECHNICAL_DOCS_SUCCESS:
      return {
        ...state,
        technicalDocs: data,
        loading: false,
      };
    case UPDATE_TECHNICAL_DOCS_FAILED:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case DELETE_TECHNICAL_DOCS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_TECHNICAL_DOCS_SUCCESS:
      return {
        ...state,
        technicalDocs: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_TECHNICAL_DOCS_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export default TechnicalDocsReducer;
